import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('trxl_lang') || 'de');
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  const loadTranslations = useCallback(async (language) => {
    try {
      const res = await fetch(`${API}/api/i18n/translations/${language}`);
      const data = await res.json();
      if (res.ok) {
        setTranslations(data.translations || {});
      }
    } catch (err) {
      console.error('Failed to load translations:', err);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadTranslations(lang);
  }, [lang, loadTranslations]);

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    localStorage.setItem('trxl_lang', newLang);
    document.documentElement.lang = newLang;
  }, []);

  const t = useCallback((key, fallback) => {
    return translations[key] || fallback || key;
  }, [translations]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, loading, translations }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}

export function LanguageSwitcher() {
  const { lang, setLang } = useI18n();

  return (
    <div className="language-switcher" data-testid="language-switcher" style={{ display: 'flex', gap: 4 }}>
      <button
        onClick={() => setLang('de')}
        data-testid="lang-de"
        style={{
          padding: '4px 8px', borderRadius: 4, fontSize: 13, fontWeight: 600, cursor: 'pointer',
          background: lang === 'de' ? '#EC2229' : 'transparent',
          color: lang === 'de' ? '#fff' : '#9ca3af',
          border: lang === 'de' ? 'none' : '1px solid rgba(255,255,255,0.2)',
        }}
      >
        DE
      </button>
      <button
        onClick={() => setLang('en')}
        data-testid="lang-en"
        style={{
          padding: '4px 8px', borderRadius: 4, fontSize: 13, fontWeight: 600, cursor: 'pointer',
          background: lang === 'en' ? '#EC2229' : 'transparent',
          color: lang === 'en' ? '#fff' : '#9ca3af',
          border: lang === 'en' ? 'none' : '1px solid rgba(255,255,255,0.2)',
        }}
      >
        EN
      </button>
    </div>
  );
}
